export default "__VITE_ASSET__4d5fa7da__"